import { createStore } from "effector";
import { ILoginFormStore } from "./types";
import { changePasswordInputType, resetErrors, setInputValue, setLoginFormStore } from "./events";
import { authLoginFx } from "./effects";
import { INITIAL_LOGIN_STORE } from "./consts";


export const $loginFormStore = createStore<ILoginFormStore>(INITIAL_LOGIN_STORE)
	.on(setInputValue, (state, { key, value }) => {
		return {
			...state,
			[key]: {
				...state[key],
				value: value,
			}
		}
	})
	.on(changePasswordInputType, (state, { key, type }) => {
		return {
			...state,
			[key]: {
				...state[key],
				type: type,
			}
		}
	})
	.on(setLoginFormStore, (_, data) => data)
	.on(resetErrors, (state, key) => {
		return {
			...state,
			[key]: {
				...state[key],
				isValid: true,
				errorMessage: '',
			},
		}
	});


export const isPending = authLoginFx.pending;


export const $shouldRedirect = createStore(false)
	.on(authLoginFx.done, () => true);
